<template>
  <div class="login">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <h3 class="title has-text-grey">Login</h3>
            <p class="subtitle has-text-grey">Please login to proceed.</p>
            <div class="box">
              <form @submit.prevent="onSubmit">
                <b-field>
                  <b-input
                    type="email"
                    v-model="email"
                    placeholder="Your Email"
                    autofocus
                    :disabled="fetching"
                  />
                </b-field>
                <b-field>
                    <b-input
                      type="password"
                      v-model="password"
                      placeholder="Your Password"
                      password-reveal
                      :disabled="fetching"
                    />
                </b-field>
                <button
                  class="button is-block is-info is-large is-fullwidth"
                  :class="{'is-loading': fetching}"
                >
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      email: null,
      password: null,
      fetching: false,
    };
  },
  methods: {
    ...mapActions('auth', ['login']),
    onSubmit() {
      this.fetching = true;
      this.login({
        email: this.email,
        password: this.password,
      }).then(() => {
        this.$router.push({ name: 'home' });
      }).catch(() => {
        this.$toast.open({
          message: 'E-mail or Password not match. Please try again',
          type: 'is-danger',
          duration: 5000,
        });
      }).finally(() => {
        this.fetching = false;
      });
    },
  },
};
</script>
